import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import { Form } from 'antd';
import Widget from '../../Helpers/Widget';

const AutomationProvider = (props) => {
  const api = new API();
  const [autoPearlsPopup, setAutoPearlsPopup] = useState(false);
  const [autoPearlsPopupWord, setAutoPearlsPopupWord] = useState(false);
  const [autoPearlsLoader, setAutoPearlsLoader] = useState(false);
  const [autoPearlsLoaderWord, setAutoPearlsLoaderWord] = useState(false);
  const [autoPearlsWord, setAutoPearlsWord] = useState(null);
  const [autoPearlsWord1, setAutoPearlsWord1] = useState(null);
  const [autoUpdatesPopup, setAutoUpdatesPopup] = useState(false);
  const [autoUpdatesPopupWord, setAutoUpdatesPopupWord] = useState(false);
  const [autoUpdatesLoader, setAutoUpdatesLoader] = useState(false);
  const [autoUpdatesLoaderWord, setAutoUpdatesLoaderWord] = useState(false);
  const [autoUpdatesWord, setAutoUpdatesWord] = useState(null);
  const [autoUpdatesWord1, setAutoUpdatesWord1] = useState(null);
  const [autoDNBMDPopup, setAutoDNBMDPopup] = useState(false);
  const [autoDNBMDPopupWord, setAutoDNBMDPopupWord] = useState(false);
  const [autoDNBMDLoader, setAutoDNBMDLoader] = useState(false);
  const [autoDNBMDLoaderWord, setAutoDNBMDLoaderWord] = useState(false);
  const [autoDNBMDWord, setAutoDNBMDWord] = useState(null);
  const [autoDNBMDWord1, setAutoDNBMDWord1] = useState(null);
  const [autoVideosPopup, setAutoVideosPopup] = useState(false);
  const [autoVideosLoader, setAutoVideosLoader] = useState(false);
  const [autoVideosWord, setAutoVideosWord] = useState(null);
  const autoBulkUploadPearls = async (sub_id,c_id,fetchPearlsTable) => {
    setAutoPearlsLoader(true);
    if(!autoPearlsWord) {
      Widget.showMessage("error", "Please select word file");
      setAutoPearlsLoader(false);
      return;
    }
    if(!sub_id) {
      Widget.showMessage("error", "Please select subject");
      setAutoPearlsLoader(false);
      return;
    }
    const formData = new FormData();
    formData.append("file", autoPearlsWord);
    formData.append("subcategory_id", sub_id);
    await api.create("automation/pearlscsv", formData, (err, res) => {
      if(res?.data?.status === 200) {
        setAutoPearlsWord(null)
        document.getElementById("excelFile1").value = "";
        fetchPearlsTable && fetchPearlsTable(sub_id,c_id);
        setAutoPearlsLoader(false);
        setAutoPearlsPopup(false);
      } else {
        Widget.showMessage("error", "Invalid Excel Format");
      }
      setAutoPearlsLoader(false);
    })
  }

  const autoBulkUploadPearlsWord = async (sub_id,c_id) => {
    setAutoPearlsLoaderWord(true);
    if(!autoPearlsWord1) {
      Widget.showMessage("error", "Please select word file");
      setAutoPearlsLoaderWord(false);
      return;
    }
    if(!sub_id) {
      Widget.showMessage("error", "Please select subject");
      setAutoPearlsLoaderWord(false);
      return;
    }
    const formData = new FormData();
    formData.append("file", autoPearlsWord1);
    formData.append("subcategory_id", sub_id);
    await api.create("automation/pearls", formData, (err, res) => {
      if(res?.data?.status === 200) {
        setAutoPearlsWord1(null)
        document.getElementById("excelFile1").value = "";
        // fetchPearlsTable && fetchPearlsTable(sub_id,c_id);
        setAutoPearlsLoaderWord(false);
        setAutoPearlsPopupWord(false);
      } else {
        Widget.showMessage("error", "Invalid Excel Format");
      }
      setAutoPearlsLoaderWord(false);
    })
  }


  const autoBulkUploadUpdates = async (sub_id,c_id,fetchUpdatesTable) => {
    setAutoUpdatesLoader(true);
    if(!autoUpdatesWord) {
      Widget.showMessage("error", "Please select word file");
      setAutoUpdatesLoader(false);
      return;
    }
    if(!sub_id) {
      Widget.showMessage("error", "Please select subject");
      setAutoUpdatesLoader(false);
      return;
    }
    const formData = new FormData();
    formData.append("file", autoUpdatesWord);
    formData.append("subcategory_id", sub_id);
    await api.create("automation/updatescsv", formData, (err, res) => {
      if(res?.data?.status === 200) {
        setAutoUpdatesWord(null)
        document.getElementById("excelFile1").value = "";
        fetchUpdatesTable && fetchUpdatesTable(sub_id,c_id);
        setAutoUpdatesLoader(false);
        setAutoUpdatesPopup(false);
      } else {
        Widget.showMessage("error", "Invalid Excel Format");
      }
      setAutoUpdatesLoader(false);
    })
  }

  const autoBulkUploadUpdatesWord = async (sub_id,c_id,fetchUpdatesTable) => {
    setAutoUpdatesLoaderWord(true);
    if(!autoUpdatesWord1) {
      Widget.showMessage("error", "Please select word file");
      setAutoUpdatesLoaderWord(false);
      return;
    }
    if(!sub_id) {
      Widget.showMessage("error", "Please select subject");
      setAutoUpdatesLoaderWord(false);
      return;
    }
    const formData = new FormData();
    formData.append("file", autoUpdatesWord1);
    formData.append("subcategory_id", sub_id);
    await api.create("automation/updates", formData, (err, res) => {
      if(res?.data?.status === 200) {
        setAutoUpdatesWord1(null)
        document.getElementById("excelFile1").value = "";
        fetchUpdatesTable && fetchUpdatesTable(sub_id,c_id);
        setAutoUpdatesLoaderWord(false);
        setAutoUpdatesPopupWord(false);
      } else {
        Widget.showMessage("error", "Invalid Excel Format");
      }
      setAutoUpdatesLoaderWord(false);
    })
  }


  const autoBulkUploadVideos = async (sub_id, c_id, fetchVideosTable) => {
    setAutoVideosLoader(true);
    if(!autoVideosWord) {
      Widget.showMessage("error", "Please select file");
      setAutoVideosLoader(false);
      return;
    }
    if(!sub_id) {
      Widget.showMessage("error", "Please select subject");
      setAutoVideosLoader(false);
      return;
    }
    const formData = new FormData();
    formData.append("file", autoVideosWord);
    formData.append("subcategory_id", sub_id);
    await api.create("automation/videoscsv", formData, (err, res) => {
      if(res?.data?.status === 200) {
        setAutoVideosWord(null)
        const el = document.getElementById("excelFileVideos");
        if(el) el.value = "";
        fetchVideosTable && fetchVideosTable(sub_id, c_id);
        setAutoVideosLoader(false);
        setAutoVideosPopup(false);
      } else {
        Widget.showMessage("error", "Invalid Excel Format");
      }
      setAutoVideosLoader(false);
    })
  }

  const autoBulkUploadDNBMD = async (sub_id,c_id,fetchDNBMDTable) => {
    setAutoDNBMDLoader(true);
    if(!autoDNBMDWord) {
      Widget.showMessage("error", "Please select word file");
      setAutoDNBMDLoader(false);
      return;
    }
    if(!sub_id) {
      Widget.showMessage("error", "Please select subject");
      setAutoDNBMDLoader(false);
      return;
    }
    const formData = new FormData();
    formData.append("file", autoDNBMDWord);
    formData.append("subcategory_id", sub_id);
    await api.create("automation/dnbmdcsv", formData, (err, res) => {
      if(res?.data?.status === 200) {
        setAutoDNBMDWord(null)
        document.getElementById("excelFile1").value = "";
        fetchDNBMDTable && fetchDNBMDTable(sub_id,c_id);
        setAutoDNBMDLoader(false);
        setAutoDNBMDPopup(false);
      } else {
        Widget.showMessage("error", "Invalid Excel Format");
      }
      setAutoDNBMDLoader(false);
    })
  }

  const autoBulkUploadDNBMDWord = async (sub_id,c_id,fetchDNBMDTable) => {
    setAutoDNBMDLoaderWord(true);
    if(!autoDNBMDWord1) {
      Widget.showMessage("error", "Please select word file");
      setAutoDNBMDLoaderWord(false);
      return;
    }
    if(!sub_id) {
      Widget.showMessage("error", "Please select subject");
      setAutoDNBMDLoaderWord(false);
      return;
    }
    const formData = new FormData();
    formData.append("file", autoDNBMDWord1);
    formData.append("subcategory_id", sub_id);
    await api.create("automation/dnbmd", formData, (err, res) => {
      if(res?.data?.status === 200) {
        setAutoDNBMDWord1(null)
        document.getElementById("excelFile1").value = "";
        fetchDNBMDTable && fetchDNBMDTable(sub_id,c_id);
        setAutoDNBMDLoaderWord(false);
        setAutoDNBMDPopupWord(false);
      } else {
        Widget.showMessage("error", "Invalid Excel Format");
      }
      setAutoDNBMDLoaderWord(false);
    })
  }


  return (
    <Context.Provider value={{
      ...props,
      autoPearlsPopup, setAutoPearlsPopup,
      autoPearlsLoader, setAutoPearlsLoader,
      autoPearlsWord, setAutoPearlsWord,
      autoBulkUploadPearls,
      autoUpdatesPopup, setAutoUpdatesPopup,
      autoUpdatesLoader, setAutoUpdatesLoader,
      autoUpdatesWord, setAutoUpdatesWord,
      autoBulkUploadUpdates,
      autoDNBMDPopup, setAutoDNBMDPopup,
      autoDNBMDLoader, setAutoDNBMDLoader,
      autoDNBMDWord, setAutoDNBMDWord,
      autoBulkUploadDNBMD,
      autoVideosPopup, setAutoVideosPopup,
      autoVideosLoader, setAutoVideosLoader,
      autoVideosWord, setAutoVideosWord,
      autoBulkUploadVideos,
      //Word
      autoBulkUploadDNBMDWord,
      autoDNBMDLoaderWord, setAutoDNBMDLoaderWord,
      autoDNBMDPopupWord, setAutoDNBMDPopupWord,
      autoDNBMDWord1, setAutoDNBMDWord1,

      autoBulkUploadUpdatesWord,
      autoUpdatesWord1, setAutoUpdatesWord1,
      autoUpdatesPopupWord, setAutoUpdatesPopupWord,
      autoUpdatesLoaderWord, setAutoUpdatesLoaderWord,

      autoBulkUploadPearlsWord,
      autoPearlsPopupWord, setAutoPearlsPopupWord,
      autoPearlsLoaderWord, setAutoPearlsLoaderWord,
      autoPearlsWord1, setAutoPearlsWord1,
    }}>
      {props.children}
    </Context.Provider>
  )
};

export default AutomationProvider;
